export function isCandidateReadyForActivation(candidate, today) {
  const setup = candidate?.business_details || {};
  if (!setup.startDate || setup.startDate > today) return false;
  if (!Number(candidate?.requirements_required)) return true;
  return Boolean(candidate?.requirements_sent_at)
    && Number(candidate?.requirement_count) > 0
    && Number(candidate?.requirement_count) === Number(candidate?.verified_count);
}
